import Cookies from "js-cookie";
import { atom } from "nanostores";
import type {
  GetCurrentUserOutput,
  FetchUserAttributesOutput,
} from "aws-amplify/auth";
import { setSubscriptionsOnAuthChange } from "./lib/graphql";

export type Subscription = {
  status: "Active" | string;
  billFrequency: string;
  endDate: string;
  sku: string;
};

export const mainNavigationOpen = atom<boolean>(false);
export const currentUser = atom<GetCurrentUserOutput | null>(null);
export const currentUserAttributes = atom<FetchUserAttributesOutput | null>(
  null,
);
export const subscriptions = atom<Subscription[] | null>(null);
export const fsStoreData = atom<any>(null);

currentUser.subscribe(setSubscriptionsOnAuthChange);

const selectedTermDefault = Cookies.get("selected-pricing-term");
export const selectedPricingTerm = atom<string>(selectedTermDefault ?? "");
selectedPricingTerm.subscribe((value) => {
  Cookies.set("selected-pricing-term", value, { path: "/" });
});
